import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useKycNomineeVerifyMutation } from "../../redux/kycApi";
import Rejectreason from "./Rejectreason";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";

const Nominee = ({ kycTrack, refetch }) => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    country: "in", // default India
    countryCode:'91',
    dob: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    dob: "",
  });

  const [btnDisable, setBtnDisable] = useState(false);

  const [kycNomineeVerify] = useKycNomineeVerifyMutation();

  useEffect(() => {
    const nominee = kycTrack?.progress?.nominee_verification?.data;
    if (nominee) {
      setFormData({
        name: nominee.nominee_name || "",
        mobile: nominee.nominee_mobile || "",
        country: nominee.nominee_country || "in",
        countryCode:nominee.country_code || '91',
        dob: nominee.nominee_dob || "",
      });
    }
  }, [kycTrack]);

  const status = kycTrack?.progress?.nominee_verification?.status;
  const isEditable = status === "pending" || status === "rejected";

  // ✅ Mobile Validation with country rules + custom checks
  const validateMobile = (number, countryCode) => {
    if (!number) return "This field is required";

    try {
      const phoneNumber = parsePhoneNumberFromString("+" + number);
      if (!phoneNumber || !phoneNumber.isValid()) {
        return "Please enter a valid mobile number";
      }

      const nationalNumber = phoneNumber.nationalNumber;

      // ❌ prevent sequential numbers
      if (
        "1234567890".includes(nationalNumber) ||
        "0987654321".includes(nationalNumber)
      ) {
        return "Sequential numbers are not allowed";
      }

      // ❌ prevent same digit numbers
      if (/^(\d)\1+$/.test(nationalNumber)) {
        return "All digits cannot be the same";
      }

      return "";
    } catch (err) {
      return "Invalid mobile number";
    }
  };

  const handleNameChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (!value) {
      setErrors((prev) => ({ ...prev, name: "This field is required" }));
    } else if (value.length < 2) {
      setErrors((prev) => ({
        ...prev,
        name: "Name must be at least 2 characters",
      }));
    } else if (value.length > 35) {
      setErrors((prev) => ({
        ...prev,
        name: "Name must be at most 35 characters",
      }));
    } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        name: "Please enter a valid nominee name",
      }));
    } else {
      setErrors((prev) => ({ ...prev, name: "" }));
    }
  };

  const handleDobChange = (e) => {
    setFormData((prev) => ({ ...prev, dob: e.target.value }));
    setErrors((prev) => ({ ...prev, dob: "" }));
  };

  const validateBeforeSubmit = () => {
    let valid = true;
    const newErrors = { name: "", mobile: "", dob: "" };

    const { name, mobile, countryCode, dob } = formData;

    // ✅ Name check
    if (!name) {
      newErrors.name = "This field is required";
      valid = false;
    } else if (name.length < 2) {
      newErrors.name = "Name must be at least 2 characters";
      valid = false;
    } else if (name.length > 35) {
      newErrors.name = "Name must be at most 35 characters";
      valid = false;
    } else if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(name)) {
      newErrors.name = "Please enter a valid nominee name";
      valid = false;
    }

    // ✅ Mobile check
    const mobileError = validateMobile(mobile, countryCode);
    if (mobileError) {
      newErrors.mobile = mobileError;
      valid = false;
    }

    // ✅ DOB + age check
    if (!dob) {
      newErrors.dob = "This field is required";
      valid = false;
    } else {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if (age < 18) {
        newErrors.dob = "Nominee age should be at least 18 years old";
        valid = false;
      }
    }

    setErrors(newErrors);
    return valid;
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (!validateBeforeSubmit()) return;

    setBtnDisable(true);
    setTimeout(() => setBtnDisable(false), 3000);

    const { name, mobile, dob, countryCode, country } = formData;

    const { data, error } = await kycNomineeVerify({
      nominee_name: name,
      nominee_mobile: mobile,
      nominee_country: country,
      country_code:countryCode,
      nominee_dob: dob,
    });

    if (error) {
      toast.error(error?.data?.message || "Something went wrong");
      return;
    }

    if (data?.status) {
      toast.success(data?.message || "Nominee details submitted");
      refetch();
    } else {
      toast.error(data?.message || "Failed to submit nominee info");
    }
  };

  return (
    <div className="upi-outer">
      <div className="">
        {/* <div className="col-md-3 col-12"></div> */}
        <div className="">
          <div className="white_box">
            <h6 className="position-relative">Nominee Verification</h6>
            <b className="mt-0">Requirements</b>
            <ul className="dit_ul mb-4">
              <li>Please Fill Your Nominee Form</li>
            </ul>
            <div className="row">
              <div className="form-group col-lg-4 col-md-6">
                <label>Nominee Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Nominee Name"
                  name="name"
                  value={formData.name}
                  onChange={handleNameChange}
                  disabled={!isEditable}
                />
                {errors.name && (
                  <div className="text-danger">{errors.name}</div>
                )}
              </div>

              <div className="form-group col-lg-4 col-md-6">
                <label>Nominee Mobile Number</label>
                <PhoneInput
                  country={formData.country}
                  value={formData.mobile}
                  onChange={(value, country) => {
                    // Clear previous error
                    setErrors((prev) => ({ ...prev, mobile: "" }));

                    if (!value) {
                      // Reset to India when the field is cleared
                      setFormData((prev) => ({
                        ...prev,
                        mobile: "",
                        country: country.iso2,
                        countryCode:country?.dialCode
                      }));
                      return;
                    }

                    // Update with current value and detected country
                    setFormData((prev) => ({
                      ...prev,
                      mobile: value,
                      country: country?.iso2 || "in", // fallback to India
                      countryCode:country?.dialCode
                    }));

                    // Run validation on the entered number
                    const err = validateMobile(value, country?.iso2 || "in");
                    setErrors((prev) => ({ ...prev, mobile: err }));
                  }}
                  disabled={!isEditable}
                  inputClass="form-control"
                  enableSearch={true}
                  searchPlaceholder="Search country..."
                  placeholder="+91"
               
                  countryCodeEditable={false}
                />

                {errors.mobile && (
                  <div className="text-danger">{errors.mobile}</div>
                )}
              </div>

              <div className="form-group col-lg-4 col-md-6">
                <label>Nominee DOB</label>
                <input
                  type="date"
                  className="form-control"
                  name="dob"
                  value={formData.dob}
                  onChange={handleDobChange}
                  disabled={!isEditable}
                  min={"1960-01-01"}
                />
                {errors.dob && <div className="text-danger">{errors.dob}</div>}
              </div>
            </div>

            {isEditable && (
              <div className="save-btn">
                <button
                  className="btn btn_man mt-3"
                  disabled={btnDisable}
                  onClick={submitForm}
                >
                  {status === "pending" ? "Submit" : "Re-Submit"}
                </button>
              </div>
            )}
            <Rejectreason
              status={status}
              reason={kycTrack?.progress?.nominee_verification?.data?.reason}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nominee;
